export default {
	"ar": {
		"VerticalEmbed_Products_Button": "شراء الآن",
		"VerticalEmbed_Events_Button": "تسجيل الآن",
		"VerticalEmbed_Bookings_Button": "حجز الآن",
		"UploadFile_Viewer_Download": "تنزيل {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} س",
		"VerticalEmbed_Units_Minute": "{{minutes}} د"
	},
	"bg": {
		"VerticalEmbed_Products_Button": "Купете сега",
		"VerticalEmbed_Events_Button": "Регистрирайте се сега",
		"VerticalEmbed_Bookings_Button": "Резервирайте сега",
		"UploadFile_Viewer_Download": "Изтегляне на {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}ч.",
		"VerticalEmbed_Units_Minute": "{{minutes}}мин."
	},
	"ca": {
		"VerticalEmbed_Products_Button": "Compra ara",
		"VerticalEmbed_Events_Button": "Registra't ara",
		"VerticalEmbed_Bookings_Button": "Reserva ara",
		"UploadFile_Viewer_Download": "Baixa {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} h",
		"VerticalEmbed_Units_Minute": "{{minutes}} min"
	},
	"cs": {
		"VerticalEmbed_Products_Button": "Koupit",
		"VerticalEmbed_Events_Button": "Registrovat",
		"VerticalEmbed_Bookings_Button": "Rezervovat",
		"UploadFile_Viewer_Download": "Stáhnout {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} h",
		"VerticalEmbed_Units_Minute": "{{minutes}} min"
	},
	"da": {
		"VerticalEmbed_Products_Button": "Køb nu",
		"VerticalEmbed_Events_Button": "Tilmeld dig",
		"VerticalEmbed_Bookings_Button": "Book nu",
		"UploadFile_Viewer_Download": "Download {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} t",
		"VerticalEmbed_Units_Minute": "{{minutes}} min"
	},
	"de": {
		"VerticalEmbed_Products_Button": "Jetzt kaufen",
		"VerticalEmbed_Events_Button": "Jetzt anmelden",
		"VerticalEmbed_Bookings_Button": "Jetzt buchen",
		"UploadFile_Viewer_Download": "{{fileType}} herunterladen",
		"VerticalEmbed_Units_Hour": "{{hours}} Std.",
		"VerticalEmbed_Units_Minute": "{{minutes}} Min."
	},
	"el": {
		"VerticalEmbed_Products_Button": "Αγορά τώρα",
		"VerticalEmbed_Events_Button": "Εγγραφείτε τώρα",
		"VerticalEmbed_Bookings_Button": "Κάντε κράτηση τώρα",
		"UploadFile_Viewer_Download": "Λήψη {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}ω",
		"VerticalEmbed_Units_Minute": "{{minutes}} λεπτά"
	},
	"en": {
		"Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
		"Poll_Viewer_ShowAllOptions_CTA": "See All Options",
		"Spoiler_Reveal_Tooltip": "Click to reveal",
		"VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
		"Viewer_Toolbar_Twitter_Tooltip": "Tweet this",
		"CollapsibleListPlugin_CollapseButton_AriaLabel": "Item is collapsed",
		"Spoiler_Reveal_Video_CTA": "Reveal Video",
		"VerticalEmbed_Pricing_Plan": "Plan only",
		"Image_Expand_Button_AriaLabel": "Expand image",
		"VerticalEmbed_From_Price": "From",
		"Poll_Viewer_ShowAllResults_CTA": "See All Results",
		"Spoiler_Reveal_Image_Placeholder": "This image contains a spoiler",
		"VerticalEmbed_Ribbon": "Sale",
		"Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Seek slider",
		"VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
		"Poll_Viewer_Multiselect_Footer": "You can vote for more than one answer.",
		"Audio_Plugin_More_Actions_Button_AriaLabel": "Show more audio controls",
		"VerticalEmbed_Booking_Fetch_Error_Title": "Service couldn’t be loaded",
		"Fullscreen_Close_Button_AriaLabel": "Close",
		"VerticalEmbed_Event_Fetch_Error_Title": "Event couldn't be loaded",
		"UploadFile_Viewer_Loader": "Loading {{fileType}}",
		"Polls_Plugin_User_Avatar_Alt": "User avatar",
		"Preview_ReadMore_Label": "Read more",
		"Spoiler_Insert_Tooltip": "Spoiler",
		"VerticalEmbed_Product_Fetch_Error_Title": "Product couldn’t be loaded",
		"Fullscreen_Shrink_Button_AriaLabel": "Shrink",
		"Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volume",
		"Spoiler_Reveal_Gallery_Placeholder": "This gallery contains a spoiler",
		"Fullscreen_Expand_Button_AriaLabel": "Expand",
		"VerticalEmbed_Bookings_Button": "Book Now",
		"Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Unmute",
		"Spoiler_Reveal_Gallery_CTA": "Reveal Gallery",
		"Poll_Viewer_ShowLess_CTA": "Show Less",
		"VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
		"Audio_Plugin_Volume_Control_Mute_AriaLabel": "Mute",
		"Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonymous",
		"Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Follow",
		"VerticalEmbed_Products_Button": "Buy Now",
		"Poll_Viewer_Toast_Error_ServerDown": "Couldn't connect to server. Try again later.",
		"Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} person voted for this answer",
		"Poll_Viewer_VoteCount": "{{number}} votes",
		"VerticalEmbed_Events_Button": "Register Now",
		"Spoiler_Reveal_Image_CTA": "Reveal Image",
		"Poll_Viewer_Toast_Error_Connection": "No internet. Check your connection.",
		"Poll_Viewer_Visibility_Owner_Footer": "Only you can see the results.",
		"VerticalEmbed_Booking_Error_Title": "Service deleted",
		"VerticalEmbed_Product_Error_Title": "Product deleted",
		"VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
		"Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} people voted for this answer",
		"VerticalEmbed_Event_Error_Title": "Event deleted",
		"CollapsibleListPlugin_ExpandButton_AriaLabel": "Item is expanded",
		"Audio_Plugin_Cover_Alt": "Audio cover",
		"Spoiler_Reveal_Video_Placeholder": "This video contains a spoiler",
		"VerticalEmbed_Product_Fetch_Error_Subtitle": "There was a technical issue. Check your connection or try again.",
		"VerticalEmbed_Fetch_Error_Title": "Failed to load item",
		"Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
		"VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
		"VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
		"Preview_SeeFullPost_Label": "See Full Post",
		"UploadFile_Viewer_Download": "Download {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}h",
		"VerticalEmbed_Units_Minute": "{{minutes}}min",
		"VerticalEmbed_Event_Fetch_Error_Subtitle": "There was a technical issue. Check your connection or try again.",
		"VerticalEmbed_Error_Button": "Replace",
		"VerticalEmbed_Error_Title": "Item deleted",
		"VerticalEmbed_Booking_Fetch_Error_Subtitle": "There was a technical issue. Check your connection or try again.",
		"Poll_Viewer_Option_AriaLabel_Checked": "checked"
	},
	"es": {
		"VerticalEmbed_Products_Button": "Comprar ahora",
		"VerticalEmbed_Events_Button": "Registrarse",
		"VerticalEmbed_Bookings_Button": "Reservar ahora",
		"UploadFile_Viewer_Download": "Descargar {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}h",
		"VerticalEmbed_Units_Minute": "{{minutes}}min"
	},
	"fi": {
		"VerticalEmbed_Products_Button": "Osta nyt",
		"VerticalEmbed_Events_Button": "Rekisteröidy nyt",
		"VerticalEmbed_Bookings_Button": "Varaa nyt",
		"UploadFile_Viewer_Download": "Lataa {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} t",
		"VerticalEmbed_Units_Minute": "{{minutes}} min"
	},
	"fr": {
		"VerticalEmbed_Products_Button": "Acheter",
		"VerticalEmbed_Events_Button": "S'inscrire",
		"VerticalEmbed_Bookings_Button": "Réserver",
		"UploadFile_Viewer_Download": "Télécharger {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} h",
		"VerticalEmbed_Units_Minute": "{{minutes}} min"
	},
	"he": {
		"VerticalEmbed_Products_Button": "לקנייה",
		"VerticalEmbed_Events_Button": "להרשמה",
		"VerticalEmbed_Bookings_Button": "הזמינו עכשיו",
		"UploadFile_Viewer_Download": "הורידו את {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} שעות",
		"VerticalEmbed_Units_Minute": "{{minutes}} דקות"
	},
	"hi": {
		"VerticalEmbed_Products_Button": "अभी खरीदें",
		"VerticalEmbed_Events_Button": "अभी पंजीकरण करें",
		"VerticalEmbed_Bookings_Button": "अभी बुक करें",
		"UploadFile_Viewer_Download": "{{fileType}} डाउनलोड करें",
		"VerticalEmbed_Units_Hour": "{{hours}}h",
		"VerticalEmbed_Units_Minute": "{{minutes}}मिनट"
	},
	"hr": {
		"VerticalEmbed_Products_Button": "Kupi odmah",
		"VerticalEmbed_Events_Button": "Prijavi se odmah",
		"VerticalEmbed_Bookings_Button": "Rezerviraj odmah",
		"UploadFile_Viewer_Download": "Preuzmi {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}h",
		"VerticalEmbed_Units_Minute": "{{minutes}}min"
	},
	"hu": {
		"VerticalEmbed_Products_Button": "Vásárlás most",
		"VerticalEmbed_Events_Button": "Regisztráció most",
		"VerticalEmbed_Bookings_Button": "Foglalás most",
		"UploadFile_Viewer_Download": "{{fileType}} letöltése",
		"VerticalEmbed_Units_Hour": "{{hours}} óra",
		"VerticalEmbed_Units_Minute": "{{minutes}} perc"
	},
	"id": {
		"VerticalEmbed_Products_Button": "Beli Sekarang",
		"VerticalEmbed_Events_Button": "Daftar Sekarang",
		"VerticalEmbed_Bookings_Button": "Pesan Sekarang",
		"UploadFile_Viewer_Download": "Unduh {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}j",
		"VerticalEmbed_Units_Minute": "{{minutes}}mnt"
	},
	"it": {
		"VerticalEmbed_Products_Button": "Acquista",
		"VerticalEmbed_Events_Button": "Registrati",
		"VerticalEmbed_Bookings_Button": "Prenota",
		"UploadFile_Viewer_Download": "Scarica {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} h",
		"VerticalEmbed_Units_Minute": "{{minutes}} min"
	},
	"ja": {
		"VerticalEmbed_Products_Button": "購入する",
		"VerticalEmbed_Events_Button": "今すぐ登録",
		"VerticalEmbed_Bookings_Button": "今すぐ予約",
		"UploadFile_Viewer_Download": "ダウンロード：{{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}時間",
		"VerticalEmbed_Units_Minute": "{{minutes}}分"
	},
	"ko": {
		"VerticalEmbed_Products_Button": "구매하기",
		"VerticalEmbed_Events_Button": "등록하기",
		"VerticalEmbed_Bookings_Button": "예약하기",
		"UploadFile_Viewer_Download": "{{fileType}} 다운로드",
		"VerticalEmbed_Units_Hour": "{{hours}}시간",
		"VerticalEmbed_Units_Minute": "{{minutes}}분"
	},
	"lt": {
		"VerticalEmbed_Products_Button": "Pirkti",
		"VerticalEmbed_Events_Button": "Registruotis",
		"VerticalEmbed_Bookings_Button": "Užsakyti",
		"UploadFile_Viewer_Download": "Atsisiųsti {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} val.",
		"VerticalEmbed_Units_Minute": "{{minutes}} min."
	},
	"lv": {
		"VerticalEmbed_Products_Button": "Pērciet tūlīt",
		"VerticalEmbed_Events_Button": "Reģistrējieties tūlīt",
		"VerticalEmbed_Bookings_Button": "Rezervējiet tūlīt",
		"UploadFile_Viewer_Download": "Lejupielādēt {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} h",
		"VerticalEmbed_Units_Minute": "{{minutes}} min"
	},
	"ms": {
		"VerticalEmbed_Products_Button": "Beli Sekarang",
		"VerticalEmbed_Events_Button": "Daftar Sekarang",
		"VerticalEmbed_Bookings_Button": "Tempah Sekarang",
		"UploadFile_Viewer_Download": "Muat turun {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{jam}}j",
		"VerticalEmbed_Units_Minute": "{{minit}}min"
	},
	"nl": {
		"VerticalEmbed_Products_Button": "Nu kopen",
		"VerticalEmbed_Events_Button": "Nu registreren",
		"VerticalEmbed_Bookings_Button": "Nu boeken",
		"UploadFile_Viewer_Download": "Download {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{uur}}u",
		"VerticalEmbed_Units_Minute": "{{minuten}}min"
	},
	"no": {
		"VerticalEmbed_Products_Button": "Kjøp nå",
		"VerticalEmbed_Events_Button": "Registrer deg nå",
		"VerticalEmbed_Bookings_Button": "Book nå",
		"UploadFile_Viewer_Download": "Last ned {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}t",
		"VerticalEmbed_Units_Minute": "{{minutes}}min"
	},
	"pl": {
		"VerticalEmbed_Products_Button": "Kup teraz",
		"VerticalEmbed_Events_Button": "Zarejestruj się teraz",
		"VerticalEmbed_Bookings_Button": "Zarezerwuj teraz",
		"UploadFile_Viewer_Download": "Pobierz {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}h",
		"VerticalEmbed_Units_Minute": "{{minutes}}min"
	},
	"pt": {
		"VerticalEmbed_Products_Button": "Comprar",
		"VerticalEmbed_Events_Button": "Registrar-se",
		"VerticalEmbed_Bookings_Button": "Agendar",
		"UploadFile_Viewer_Download": "Fazer download de {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}h",
		"VerticalEmbed_Units_Minute": "{{minutes}}min"
	},
	"ro": {
		"VerticalEmbed_Products_Button": "Cumpără acum",
		"VerticalEmbed_Events_Button": "Înregistrează-te acum",
		"VerticalEmbed_Bookings_Button": "Rezervă acum",
		"UploadFile_Viewer_Download": "Descarcă {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} h",
		"VerticalEmbed_Units_Minute": "{{minutes}} min"
	},
	"ru": {
		"VerticalEmbed_Products_Button": "Купить",
		"VerticalEmbed_Events_Button": "Зарегистрироваться",
		"VerticalEmbed_Bookings_Button": "Забронировать",
		"UploadFile_Viewer_Download": "Скачать {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} ч.",
		"VerticalEmbed_Units_Minute": "{{minutes}} мин."
	},
	"sk": {
		"VerticalEmbed_Products_Button": "Kúpiť teraz",
		"VerticalEmbed_Events_Button": "Zaregistrujte sa teraz",
		"VerticalEmbed_Bookings_Button": "Rezervovať teraz",
		"UploadFile_Viewer_Download": "Stiahnuť {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}h",
		"VerticalEmbed_Units_Minute": "{{minutes}}min"
	},
	"sl": {
		"VerticalEmbed_Products_Button": "Kupi zdaj",
		"VerticalEmbed_Events_Button": "Registrirajte se zdaj",
		"VerticalEmbed_Bookings_Button": "Rezerviraj zdaj",
		"UploadFile_Viewer_Download": "Prenos {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}h",
		"VerticalEmbed_Units_Minute": "{{minutes}} min"
	},
	"sv": {
		"VerticalEmbed_Products_Button": "Köp nu",
		"VerticalEmbed_Events_Button": "Registrera dig nu",
		"VerticalEmbed_Bookings_Button": "Boka nu",
		"UploadFile_Viewer_Download": "Ladda ner {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} t",
		"VerticalEmbed_Units_Minute": "{{minutes}} min"
	},
	"th": {
		"VerticalEmbed_Products_Button": "ซื้อเลย",
		"VerticalEmbed_Events_Button": "ลงทะเบียนตอนนี้",
		"VerticalEmbed_Bookings_Button": "จองเลย",
		"UploadFile_Viewer_Download": "ดาวน์โหลด {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} ชม.",
		"VerticalEmbed_Units_Minute": "{{minutes}} นาที"
	},
	"tl": {
		"VerticalEmbed_Products_Button": "Bumili Na",
		"VerticalEmbed_Events_Button": "Magparehistro Na",
		"VerticalEmbed_Bookings_Button": "Mag-book Na",
		"UploadFile_Viewer_Download": "I-download ang {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}}h",
		"VerticalEmbed_Units_Minute": "{{minutes}}min"
	},
	"tr": {
		"VerticalEmbed_Products_Button": "Satın Al",
		"VerticalEmbed_Events_Button": "Hemen Kaydol",
		"VerticalEmbed_Bookings_Button": "Yer Ayırt",
		"UploadFile_Viewer_Download": "{{fileType}} dosyasını indir",
		"VerticalEmbed_Units_Hour": "{{hours}} sa.",
		"VerticalEmbed_Units_Minute": "{{minutes}} dk."
	},
	"uk": {
		"VerticalEmbed_Products_Button": "Купити зараз",
		"VerticalEmbed_Events_Button": "Зареєструватися",
		"VerticalEmbed_Bookings_Button": "Записатися",
		"UploadFile_Viewer_Download": "Завантажити {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} год.",
		"VerticalEmbed_Units_Minute": "{{minutes}} хв."
	},
	"vi": {
		"VerticalEmbed_Products_Button": "Mua ngay",
		"VerticalEmbed_Events_Button": "Đăng ký ngay",
		"VerticalEmbed_Bookings_Button": "Đặt ngay",
		"UploadFile_Viewer_Download": "Tải về {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} giờ",
		"VerticalEmbed_Units_Minute": "{{minutes}} phút"
	},
	"zh": {
		"VerticalEmbed_Products_Button": "立即購買",
		"VerticalEmbed_Events_Button": "立即報名",
		"VerticalEmbed_Bookings_Button": "立即預訂",
		"UploadFile_Viewer_Download": "下載 {{fileType}}",
		"VerticalEmbed_Units_Hour": "{{hours}} 小時",
		"VerticalEmbed_Units_Minute": "{{minutes}} 分鐘"
	}
}